import { Vue, Component, Prop } from 'vue-property-decorator'
import Disease from '~/types/api/disease/DiseaseItem'
import ArrowSvg from '~/assets/svg/link-arrow.svg?inline'
import ArrowLinkSvg from '~/assets/svg/arrow-search.svg?inline'
import loc from '~/utils/loc'
import MarkingAd from '~/components/element/MarkingAd'

@Component
export default class DiseaseItem extends Vue {
  isShow: boolean = false

  @Prop({ required: true, type: Object })
  readonly item!: Disease

  get location () {
    return loc(this.$store, {
      name: 'disease-code',
      params: {
        code: this.item.code
      }
    })
  }

  render () {
    return (
      <div class="disease-item">
        <div class="disease-item__header" onClick={() => { this.isShow = !this.isShow }}>
          <div class="disease-item__name">
            {this.item.name}
          </div>
          <div class={{
            'disease-item__arrow': true,
            'disease-item__arrow_show': this.isShow
          }}>
            <ArrowSvg />
          </div>
        </div>
        {this.isShow &&
          <div class="disease-item__content">
            <div class="disease-item__text">
              {this.item.description}
            </div>
            <div class="disease-item__marking-Ad">
              {this.item.marking?.id &&
              <MarkingAd {...{
                props: {
                  info: this.item.marking
                }
              }}/>
              }
            </div>
            <nuxt-link to={this.location} class="disease-item__link">
              <div class="disease-item__link-arrow">
                <ArrowLinkSvg />
              </div>
              <div class="disease-item__link-link">
                В раздел
              </div>
            </nuxt-link>
          </div>
        }
      </div>
    )
  }
}
